import { atom } from "jotai";

export const horizontalHelperLineAtom = atom<number | undefined>(undefined);
horizontalHelperLineAtom.debugLabel = "horizontalHelperLineAtom";

export const verticalHelperLineAtom = atom<number | undefined>(undefined);
verticalHelperLineAtom.debugLabel = "verticalHelperLineAtom";
